export default __webpack_public_path__ + "static/media/ThinkLegal.ffc3c37aa7e197c6455af1edbb361336.webp";